import { render, staticRenderFns } from "./userprofile.vue?vue&type=template&id=56cb120e&scoped=true&"
import script from "./userprofile.vue?vue&type=script&lang=js&"
export * from "./userprofile.vue?vue&type=script&lang=js&"
import style0 from "./userprofile.vue?vue&type=style&index=0&id=56cb120e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb120e",
  null
  
)

export default component.exports